import { Injectable } from '@angular/core';
import { FormControl } from '@angular/forms';

@Injectable()
export class DateHelper {
  constructor() { }

  public convertBootstrapDate(year: number, month: number, day: number): any {
    return new Date(year, month, day);
  }

  public compareTwoBootstrapDate(startDate: FormControl, endDate: FormControl): any {
    if (startDate && endDate) {
      const start = new Date(startDate.value.year, startDate.value.month, startDate.value.day);
      const end = new Date(endDate.value.year, endDate.value.month, endDate.value.day);

      return end > start;
    } else {
      return false;
    }
  }

  /**
   *
   * @param before date in format yyyy-mm-dd
   */
  public stringToDate(before: string): any {
    if (before) {
      const temp = before.split('-');
      const after = {
        year: Number(temp[0]),
        month: Number(temp[1]),
        day: Number(temp[2])
      };
      return after;
    }
  }

  public dateToString(before: any): any {
    let after;
    if (before.month < 10 && before.day < 10) {
      after = before.year + '-0' + before.month + '-0' + before.day;
    } else if (before.month < 10) {
      after = before.year + '-0' + before.month + '-' + before.day;
    } else if (before.day < 10) {
      after = before.year + '-' + before.month + '-0' + before.day;
    } else {
      after = before.year + '-' + before.month + '-' + before.day;
    }
    return after;
  }

  public dateToNgxDate(d: Date): any {
    return {
      year: d.getFullYear(),
      month: d.getMonth() + 1,
      day: d.getDay()
    };
  }

}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/helper/dateHelper.ts